import services from '@/utils/request';





// 店铺消息列表 


export function ShopNotifyList(parms) {

    return services.request({
        method: 'GET',
        url: "/notify/list",
        params:parms
    })
}
// 标记已读
export function ShopNotifyRead(parms) {

    return services.request({
        method: 'POST',
        url: "/notify/read",
        data:parms
    })
}
// 全部标记已读
export function ShopNotifyReadAll(parms) {

    return services.request({
        method: 'POST',
        url: "/notify/read/all",
        data:parms
    })
}